module.exports = "<nv-react-component class=\"lecture-page-router\" component=\"LecturePageRouter\"></nv-react-component>";